import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { Store } from "./storage";

const storage = Store("local");

const State = {
  pageName: "Home",
  errorMessage: "",
  showAlert: false,
  loading: false,
  addressAPILoading: false,
  propertyInfo: {},
  garbageInfo: {},
  propertyInfoMapBoundaries: [],
  nearbySchools: {},
  votingInfo: {},
  nearbyPolice: [],
  nearbyFire: [],
  nearbyParks: [],
  nearbyLibraries: [],
  notificationSubscription: { show: false, type: "" },
  notificationToken: null,
  webGoogleMapsApiKey: null,
  firebaseApiKey: null,
  alerts: [],
  links: [],
  payLinks: [],
  webInstaller: {
    installed: false,
    installerDismissed: false,
    promptWasShown: false,
    sessionSuppress: false,
  },
};

const Actions = (_set, get) => {
  const set = _set;

  const setPageName = (name) => {
    set({ pageName: name });
  };

  const setLoading = (isLoading) => {
    set({ loading: isLoading });
  };

  const setErrorMessage = (msg) => {
    set({ errorMessage: msg });
  };

  const setShowAlert = (show) => {
    set({ showAlert: show });
  };

  const setAddressAPILoading = (isLoading) => {
    set({ addressAPILoading: isLoading });
  };

  const setPropertyInfo = (data) => {
    set({ propertyInfo: data });
  };

  const setGarbageInfo = (garbageData) => {
    set({ garbageInfo: garbageData });
  };

  const setPropertyInfoMapBoundaries = (boundaries) => {
    set({ propertyInfoMapBoundaries: boundaries });
  };

  const setVotingInfo = (votingInfo) => {
    set({ votingInfo });
  };

  const setNearbySchools = (schools) => {
    set({ nearbySchools: schools });
  };

  const setNearbyPolice = (police) => {
    set({ nearbyPolice: police });
  };

  const setNearbyFire = (fire) => {
    set({ nearbyFire: fire });
  };

  const setNearbyParks = (parks) => {
    set({ nearbyParks: parks });
  };

  const setNearbyLibraries = (libraries) => {
    set({ nearbyLibraries: libraries });
  };

  const setNotificationSubscription = ({ show, type }) => {
    set({ notificationSubscription: { show, type } });
  };

  const setNotificationToken = (token) => {
    set({ notificationToken: token });
  };

  const setWebGoogleMapsApiKey = (apiKey) => {
    set({ webGoogleMapsApiKey: apiKey });
  };

  const setFirebaseApiKey = (apiKey) => {
    set({ firebaseApiKey: apiKey });
  };

  const setAlerts = (alerts) => {
    set({ alerts });
  };

  const setLinks = (links) => {
    set({ links });
  };

  const setPayLinks = (payLinks) => {
    set({ payLinks });
  };

  const setWebInstaller = (installerState) => {
    set({ webInstaller: { ...get().webInstaller, ...installerState } });
  };

  const clearAllPropertyInfo = () => {
    set({
      propertyInfo: {},
      garbageInfo: {},
      propertyInfoMapBoundaries: [],
      votingInfo: {},
      nearbySchools: {},
      nearbyPolice: [],
      nearbyFire: [],
      nearbyParks: [],
      nearbyLibraries: [],
    });
  };

  return {
    setPageName,
    setLoading,
    setErrorMessage,
    setShowAlert,
    setAddressAPILoading,
    setPropertyInfo,
    setGarbageInfo,
    setPropertyInfoMapBoundaries,
    setVotingInfo,
    setNearbySchools,
    setNearbyPolice,
    setNearbyFire,
    setNearbyParks,
    setNearbyLibraries,
    setNotificationSubscription,
    setNotificationToken,
    setWebGoogleMapsApiKey,
    setFirebaseApiKey,
    setAlerts,
    setLinks,
    setPayLinks,
    setWebInstaller,
    clearAllPropertyInfo,
  };
};

export default create(
  persist(
    (set, get) => {
      const actions = Actions(set, get);
      return {
        ...State,
        setPageName: actions.setPageName,
        setLoading: actions.setLoading,
        setErrorMessage: actions.setErrorMessage,
        setShowAlert: actions.setShowAlert,
        setAddressAPILoading: actions.setAddressAPILoading,
        setPropertyInfo: actions.setPropertyInfo,
        setGarbageInfo: actions.setGarbageInfo,
        setPropertyInfoMapBoundaries: actions.setPropertyInfoMapBoundaries,
        setVotingInfo: actions.setVotingInfo,
        setNearbySchools: actions.setNearbySchools,
        setNearbyPolice: actions.setNearbyPolice,
        setNearbyFire: actions.setNearbyFire,
        setNearbyParks: actions.setNearbyParks,
        setNearbyLibraries: actions.setNearbyLibraries,
        setNotificationSubscription: actions.setNotificationSubscription,
        setNotificationToken: actions.setNotificationToken,
        setWebGoogleMapsApiKey: actions.setWebGoogleMapsApiKey,
        setFirebaseApiKey: actions.setFirebaseApiKey,
        setAlerts: actions.setAlerts,
        setLinks: actions.setLinks,
        setPayLinks: actions.setPayLinks,
        setWebInstaller: actions.setWebInstaller,
        clearAllPropertyInfo: actions.clearAllPropertyInfo,
      };
    },
    {
      name: "app.global",
      storage: createJSONStorage(() => storage),
    }
  )
);
